var _excluded = ["title", "height", "imageList", "closeAutoSwitch"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React, { forwardRef, useImperativeHandle } from 'react';
import { EnhanceComponent } from "../../middleware/EnhanceComponent";
import setting from "./setting";
import { getPrefixCls } from "../../utils/common";
import "./style.less";
import { CommonSwiper, SwiperItem } from "../../common";
import { defaultImageList } from "../../utils/constants";
import NewImage from "../NewImage";
import { useToggleVisible } from "../../hooks/useToggleVisible";
var Swiper = /*#__PURE__*/forwardRef(function (props, ref) {
  var title = props.title,
    height = props.height,
    _props$imageList = props.imageList,
    imageList = _props$imageList === void 0 ? defaultImageList : _props$imageList,
    closeAutoSwitch = props.closeAutoSwitch,
    rest = _objectWithoutProperties(props, _excluded);
  var prefixCls = getPrefixCls('SmSwiper');
  var _useToggleVisible = useToggleVisible(),
    tabVisible = _useToggleVisible.visible,
    _toggleVisible = _useToggleVisible.toggleVisible;
  var swiperRef = React.useRef(null);
  useImperativeHandle(ref, function () {
    return {
      toggleVisible: function toggleVisible(boo) {
        _toggleVisible(boo);
      },
      getImagesTitle: function getImagesTitle() {
        return imageList.map(function (item) {
          return item.imgTitle;
        });
      },
      swipeTo: function swipeTo(index) {
        var _swiperRef$current;
        (_swiperRef$current = swiperRef.current) === null || _swiperRef$current === void 0 ? void 0 : _swiperRef$current.swipeTo(index);
      }
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    id: title ? "me-".concat(title) : undefined,
    style: {
      display: tabVisible ? 'block' : 'none'
    }
  }, /*#__PURE__*/React.createElement(CommonSwiper, {
    ref: swiperRef,
    style: {
      height: height ? "".concat(Number(height), "px") : '200px'
    },
    loop: true,
    autoplay: !closeAutoSwitch
  }, imageList === null || imageList === void 0 ? void 0 : imageList.map(function (item, index) {
    return /*#__PURE__*/React.createElement(SwiperItem, {
      key: index
    }, /*#__PURE__*/React.createElement(NewImage, _extends({
      src: (item === null || item === void 0 ? void 0 : item.backgroundImage) || 'http://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202310/27/95034_20231027161521.png',
      style: {
        width: '100%'
      },
      fit: "cover"
    }, item, rest, {
      isCommonComponent: true
    })));
  })));
});
var EnhancedSwiper = EnhanceComponent(Swiper);
EnhancedSwiper.settings = setting;
export default EnhancedSwiper;